import LoadingModal from "../Common/LoadingModal";

const LoadingState = () => {
  return <LoadingModal message="Loading media..." />;
};

export default LoadingState;
